import { render } from "./CareVue.vue?vue&type=template&id=6d6fbdef"
import script from "./CareVue.vue?vue&type=script&lang=js"
export * from "./CareVue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__